import { Controller } from "stimulus";
import { openModal } from "../modal/utils";

export default class extends Controller {
  openInquiry(e) {
    e.preventDefault();
    const modal = document.querySelector(".inquiry-overlay");
    openModal(modal);
  }
}
